export class SearchString {
  public domain: string;
  public system: string;
  public search: string;
}
